var SCAAFFCustomerReferSetting = {
    "program": {
        "active": true,
        "shop": "stirling-coffee.myshopify.com",
        "incentive": {
            "type": "percentage",
            "value": "20.00",
            "price_rule_id": 1068782026834,
            "coupon": "UPPROMOTE_CUSTOMER_REFERRAL"
        },
        "program": "NzYzNjg="
    },
    "design": {
        "refer_customer_button": {
            "refer_button_text": "Refer & Earn",
            "refer_background_color": "#1d85e8",
            "refer_text_color": "#ffffff",
            "web_position": "right-center",
            "mobile_position": "right-center"
        },
        "refer_customer_invite": {
            "popup_header": "Invite & Get \u00a35 off",
            "popup_description": "Send your friends a 20% discount on their purchase. When they make a purchase, you'll also earn \u00a35 for each order! This reward can be redeemed against future orders \ud83d\ude00",
            "button_text_get_invite": "Get invite link",
            "button_copy_invite": "Copy invite link",
            "popup_background_color": "#1d85e8",
            "popup_text_color": "#ffffff"
        },
        "refer_customer_incentive_popup": {
            "shop_header": "You got 20% Off",
            "shop_description": "Congrats! Your friend has gifted you a discount coupon for Stirling Coffee!!! Coupon will be automatically applied at the checkout page.",
            "shop_button_text": "Shop now",
            "shop_background_color": "#1d85e8",
            "shop_text_color": "#ffffff"
        }
    }
}